import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE_POWDER_LIGHT, GRAY_SEMIDARK} from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import VersionHistoryItemActionMenu, {
  VersionHistoryItemActionMenuProps,
} from './VersionHistoryItemActionMenu';

export interface VersionHistoryItemProps extends VersionHistoryItemActionMenuProps {
  rows: Array<JSX.Element>;
  isSelected: boolean;
  onClick?: () => void;
}

function VersionHistoryItemBase({
  rows,
  isSelected,
  onClick,
  firstOption,
  secondOption,
}: VersionHistoryItemProps): JSX.Element {
  const shouldShowActionButton = isSelected && (firstOption.onClick || secondOption.onClick);
  const actionMenu = <VersionHistoryItemActionMenu firstOption={firstOption} secondOption={secondOption} />;
  return (
    <div
      className={classNames(
        'version-history-item',
        css(styles.container, isSelected && styles.containerIsSelected, onClick && styles.containerClickable)
      )}
      onClick={onClick}
    >
      <div className={css(styles.containerContent)}>
        {rows.map((row, index) => (
          <div key={`version-history-item-row-${index}`} className={classNames('version-history-item-row')}>
            {row}
          </div>
        ))}
      </div>
      <div className={css(styles.containerActionButton)}>
        {shouldShowActionButton && (
          <Dropdown closeOnInsideClick={true} menu={actionMenu}>
            <Button
              size={ButtonSize.MINI}
              buttonStyle={ButtonStyle.TERTIARY_WHITE_TRANSPARENT}
              dataTestAttrs={{component: 'version-history-item', element: 'action-button'}}
              className={css(styles.actionButton)}
            >
              <BenchlingIcon icon="ellipsis-vertical" />
            </Button>
          </Dropdown>
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    ':hover': {
      backgroundColor: Color.GRAY_50,
    },
    padding: '10px 15px 10px 10px',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
  },
  containerIsSelected: {
    backgroundColor: BLUE_POWDER_LIGHT,
    ':hover': {
      backgroundColor: BLUE_POWDER_LIGHT,
    },
  },
  containerClickable: {
    cursor: 'pointer',
  },
  containerContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  containerActionButton: {
    flex: 0,
    marginLeft: 'auto',
  },
  actionButton: {
    padding: '6px',
    border: 'none',
    color: GRAY_SEMIDARK,
  },
});

export default VersionHistoryItemBase;
